import AutoLoadingButton from "@/components/AutoLoadingButton";
import ManualOrderConsigneeDTO from "@/dto/manualOrder/ManualOrderConsigneeDTO";
import { batchRecognizeConsignee } from "@/services/api/manualOrder";
import { useRequest } from "ahooks";
import { message } from "antd";
import React from "react";

interface QuickRecognizeAddressButtonProps {
    shopId: number;

    onRecognizeAddress: (consignee: ManualOrderConsigneeDTO, text: string) => void;
}

const QuickRecognizeAddressButton: React.FC<QuickRecognizeAddressButtonProps> = function (props) {
    const { shopId, onRecognizeAddress } = props;
    const { runAsync, loading } = useRequest(batchRecognizeConsignee, { manual: true });

    async function handleRecognizeFromClipboard() {
        try {
            const text = await readClipboardTextWithTimeout(8000);

            if (!text?.trim()) {
                message.error("剪贴板为空");
                return;
            }

            const consignees = await runAsync(shopId, [text]);

            message.success("识别完成！如果识别效果不好请手动填写并联系客服反馈");
            onRecognizeAddress(consignees[0], text);
        } catch (error) {
            message.error(error?.message);
        }
    }

    async function readClipboardTextWithTimeout(timeout: number): Promise<string> {
        return new Promise((resolve, reject) => {
            let resolved = false;

            const timer = setTimeout(() => {
                if (!resolved) {
                    reject(new Error("不支持该浏览器，请切换浏览器使用该功能"));
                }
            }, timeout);

            navigator.clipboard
                .readText()
                .then((clipboardText) => {
                    resolved = true;
                    clearTimeout(timer);
                    resolve(clipboardText || "");
                })
                .catch((error) => {
                    clearTimeout(timer);
                    reject(new Error(error?.message || "无法读取剪贴板"));
                });
        });
    }

    return (
        <AutoLoadingButton
            loading={loading}
            onClick={handleRecognizeFromClipboard}
            className="mt5 ant-btn-success mr5"
            size="small"
            type="primary"
        >
            粘贴并识别地址
        </AutoLoadingButton>
    );
};

export default React.memo(QuickRecognizeAddressButton);
